import {
  searchKeyword,
  searchTabAtom,
} from '@/features/Search/hook/search.state';
import { startTransition, useEffect, useRef } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import { useDebouncedState, useFocusWithin } from '@mantine/hooks';

import { API_ENDPOINT } from '@/config/endpoint';
import Toast from '@/components/Toast';
import { mixpanelTrack } from '@/utils/mixpanel';
import { useQuery } from '@tanstack/react-query';
import { useReplaceQueryParams } from '@/utils/utils';

export const searchWord = () => {
  const { ref, focused } = useFocusWithin();
  const { urlSearchParams, setQueryParams } = useReplaceQueryParams();

  const inputRef = useRef<HTMLInputElement>(null);

  const setValue = useSetAtom(searchTabAtom);

  const [keyword, setKeyword] = useAtom(searchKeyword);

  useEffect(() => {
    setTimeout(() => {
      inputRef.current?.blur();
    }, 0);
  }, [keyword]);

  const handleKeywordChange = (e: any) => {
    const enterWord = e?.value || inputRef.current?.value;

    if (!enterWord) return Toast.info('검색어를 입력해주세요!');

    setValue('전체');
    setKeyword(enterWord || '');

    startTransition(() => {
      mixpanelTrack('SearchPage_SearchBox_Input', 'Searched', {
        keyword: enterWord,
      });

      enterWord
        ? urlSearchParams.set('keyword', enterWord)
        : urlSearchParams.delete('keyword');
      setQueryParams(urlSearchParams);
    });
  };

  const handleKeywordChangeInApp = (keyword: string) => {
    setValue('전체');
    setKeyword(keyword || '');

    startTransition(() => {
      mixpanelTrack('SearchPage_SearchBox_Input', 'Searched', {
        keyword,
      });
    });
  };

  return {
    ref,
    focused,
    inputRef,
    keyword,
    handleKeywordChange,
    handleKeywordChangeInApp,
  };
};

export const getHints = () => {
  const [hintSearch, setHintSearch] = useDebouncedState('', 50);

  const { data: hints } = useQuery(
    ['hints', hintSearch],
    async () => await API_ENDPOINT.search.getHints(hintSearch),
    {
      keepPreviousData: true,
      enabled: !!hintSearch,
    }
  );

  return { hints, setHintSearch };
};
